import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {getEmployee, getOrganizationById, listEmployee} from "../../api/employeeInfo/employee";
import {getUserPerms} from "../../api/login";
import {listOrganization} from "../../api/employeeInfo/organization";

const user = {
  state: {
    token: getToken(),
    emName: '',
    name: '',
    avatar: '',
    roles: [],
    id: '',
    department: '',
    unit: '',
    idCard: '',
    phone: '',
    perms: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EMNAME: (state, em_name) => {
      state.emName = em_name
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_DEPARTMENT: (state, department) => {
      state.department = department
    },
    SET_UNIT: (state, unit) => {
      state.unit = unit
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_PERMS: (state, perms) => {
      state.perms = perms
    },
    SET_IDCARD: (state, idCard) => {
      state.idCard = idCard
    },

  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          if(response.status === 200){
            const tokenStr = data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            resolve()
          }else reject()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserPerms().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_PERMS', data.roles)
          } else {
            reject('getInfo: perms must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_EMNAME', data.emName)
          commit('SET_AVATAR', data.avatar)
          commit('SET_PHONE', data.phone)
          commit('SET_IDCARD', data.idCard)
          commit('SET_ID', data.id)
          commit('SET_DEPARTMENT', data.department)
          let o = {
            id: data.id
          }
          getOrganizationById(data.id).then(res =>{
            commit('SET_UNIT', res.data[0].employee_departments__pid__name)
          })
          listEmployee(o).then(res =>{
            if(res.data[0].roles && res.data[0].roles.length > 0){
              commit('SET_ROLES', res.data[0].roles)
            }else {
              reject('getInfo: roles must be a non-null array !')
            }
            resolve(res)
          })
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        // }).catch(error => {
        //   reject(error)
        // })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js